module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/rectangleConversionL_UB.c49e8277.svg";